import React, { useEffect, useState } from "react";
import { useApp } from "../../context/AppContext";
import { formatDate, formatDateTime, timeAgo } from "../../utils/format";

const toLocalInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 16);
};

function OverviewTab({ job }) {
  const { updateJob, toast } = useApp();
  const [notes, setNotes] = useState(job.notes || "");

  useEffect(() => setNotes(job.notes || ""), [job.id, job.notes]);

  const saveNotes = async () => {
    if (notes !== (job.notes || "") && (await updateJob(job.id, { notes })))
      toast("Notes saved");
  };

  return (
    <div className="d-flex flex-column gap-3">
      <div className="card">
        <div className="card-body">
          <h2 className="h6">About the role</h2>
          <p className="text-muted mb-3" style={{ whiteSpace: "pre-line" }}>
            {job.description || "No description yet."}
          </p>
          {job.requirements?.length > 0 && (
            <>
              <h3 className="h6 small text-uppercase text-muted fw-semibold">
                Key requirements
              </h3>
              <div className="d-flex flex-wrap gap-1">
                {job.requirements.map((r) => (
                  <span key={r} className="tag">
                    {r}
                  </span>
                ))}
              </div>
            </>
          )}
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="row g-3 small">
            <div className="col-6 col-md-3">
              <div className="text-muted">Source</div>
              <div className="fw-medium">{job.source || "-"}</div>
            </div>
            <div className="col-6 col-md-3">
              <div className="text-muted">Added</div>
              <div className="fw-medium">{formatDate(job.createdAt)}</div>
            </div>
            <div className="col-6 col-md-3">
              <div className="text-muted">Applied</div>
              <div className="fw-medium">
                {job.appliedAt ? formatDate(job.appliedAt) : "Not yet"}
              </div>
            </div>
            <div className="col-6 col-md-3">
              <label className="text-muted d-block" htmlFor="interview-at">
                Interview
              </label>
              <input
                id="interview-at"
                type="datetime-local"
                className="form-control form-control-sm"
                value={toLocalInput(job.interviewAt)}
                onChange={(e) =>
                  updateJob(job.id, {
                    interviewAt: e.target.value
                      ? new Date(e.target.value).toISOString()
                      : null,
                  })
                }
              />
            </div>
          </div>
          {job.interviewAt && new Date(job.interviewAt) > new Date() && (
            <div className="alert alert-info py-2 small mt-3 mb-0">
              <i className="bi bi-calendar-event me-2" />
              Interview {formatDateTime(job.interviewAt)} (
              {timeAgo(job.interviewAt)})
            </div>
          )}
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <label className="h6 d-block" htmlFor="job-notes">
            Notes
          </label>
          <textarea
            id="job-notes"
            className="form-control"
            rows={4}
            placeholder="Interview prep, people you spoke with, salary details…"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            onBlur={saveNotes}
          />
          <div className="form-text">
            Saves automatically when you click away.
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h2 className="h6 mb-3">Timeline</h2>
          <ul className="timeline">
            {[...(job.activity || [])].reverse().map((a) => (
              <li key={a.id}>
                <span className="fw-medium small">{a.text}</span>
                <span className="small text-muted ms-2">
                  {formatDate(a.at)} · {timeAgo(a.at)}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default OverviewTab;
